import * as Types from '../../generated/basetypes.graphql';

import { gql } from 'graphql-tag';
export type VendorVariantModelFragmentFragment = { __typename?: 'VendorVariantModel', availability?: string | null, dimensions?: string | null, discountedPrice?: number | null, id: string, isReturnable: boolean, sku?: string | null, title: string, material?: string | null, color?: string | null, etaText?: string | null, image?: { __typename?: 'VendorVariantMediaModel', id: string, uri: string } | null, retailPrice?: { __typename?: 'PriceModel', id: string, price?: number | null } | null, shippingType?: { __typename?: 'ShippingTypeModel', id: string, title: string } | null, taxonomy?: { __typename?: 'TaxonomyModel', id: string, title: string } | null, vendor: { __typename?: 'VendorModel', id: string, name?: string | null } };

export const VendorVariantModelFragmentFragmentDoc = gql`
    fragment VendorVariantModelFragment on VendorVariantModel {
  availability
  dimensions
  discountedPrice
  id
  isReturnable
  image {
    id
    uri
  }
  retailPrice {
    id
    price
  }
  shippingType {
    id
    title
  }
  taxonomy {
    id
    title
  }
  sku
  title
  material
  color
  etaText
  vendor {
    id
    name
  }
}
    `;
export const namedOperations = {
  Fragment: {
    VendorVariantModelFragment: 'VendorVariantModelFragment'
  }
}